// src/api/organizationApi.js
import axiosConfig from './axiosConfig';

export const organizationApi = {
  getMy: async () => {
    const response = await axiosConfig.get('/organizations/me');
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosConfig.get(`/organizations/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosConfig.put(`/organizations/${id}`, data);
    return response.data;
  },

  getStats: async () => {
    const response = await axiosConfig.get('/organizations/stats');
    return response.data;
  },

  // ✅ Aggiunto — lista utenti dell'organizzazione
  getUsers: async () => {
    const response = await axiosConfig.get('/users');
    return response.data;
  },

  // Inviti
  inviteUser: async (email, role) => {
    const response = await axiosConfig.post('/invitations/invite', { email, role });
    return response.data;
  },

  getInvitations: async () => {
    const response = await axiosConfig.get('/invitations');
    return response.data;
  },

  cancelInvitation: async (id) => {
    const response = await axiosConfig.delete(`/invitations/${id}`);
    return response.data;
  },

  resendInvitation: async (id) => {
    const response = await axiosConfig.post(`/invitations/${id}/resend`);
    return response.data;
  },

  acceptInvitation: async (token, userData) => {
    const response = await axiosConfig.post(`/invitations/accept/${token}`, userData);
    return response.data;
  },

  removeUser: async (userId) => {
    const response = await axiosConfig.delete(`/users/${userId}`);
    return response.data;
  },
};